(function(){
  var messages={
    en:'VGRPRO is loading. If this message remains, refresh the page once.',
    es:'VGRPRO se está cargando. Si este mensaje permanece, actualiza la página una vez.',
    fr:'VGRPRO est en cours de chargement. Si ce message reste affiché, actualisez la page une fois.',
    de:'VGRPRO wird geladen. Wenn diese Meldung bestehen bleibt, aktualisiere die Seite einmal.'
  };
  function check(){
    var root=document.getElementById('root');
    if(!root) return;
    if(root.childElementCount===0 && !document.getElementById('vgr-runtime-warning')){
      var d=document.createElement('div'); d.id='vgr-runtime-warning';
      d.style.cssText='padding:24px;font:14px Arial;color:#333;background:#fff';
      var locale=window.__VGRPRO_GET_FULL_LOCALE__?window.__VGRPRO_GET_FULL_LOCALE__():'en';
      d.textContent=messages[locale]||messages.en;
      root.appendChild(d);
    }
  }
  window.addEventListener('load',function(){setTimeout(check,5000)});
})();
